const metaClient = document.querySelector('meta[name=client]')
const metaSecret = document.querySelector('meta[name=secret]')
const metaBase = document.querySelector('meta[name=base]')

const base = metaBase && !!metaBase.getAttribute('content').trim() ? metaBase.getAttribute('content') : 'http://planilla.test'
const client = metaClient && !!metaClient.getAttribute('content').trim() ? metaClient.getAttribute('content') : 2
const secret = metaSecret && !!metaSecret.getAttribute('content').trim() ? Buffer.from(metaSecret.getAttribute('content'), 'base64').toString('utf8') : 'dqjL97vKDuejTeup5a2RhZmxNMzop1oBc4bGMH7J'
const api = `${base}/api`

export const baseUrl = base
export const clientId = client
export const clientSecret = secret
export const baseApi = api



// WEBPACK FOOTER //
// ./src/configs/urls.js